import { useTimeAxisContext } from "utils/customHooks/genericHooks";
import * as d3 from "d3";
import { useTimelineTooltipStore } from "./TimelineTooltip/timelineTooltipStore";

type ModalVerticalProps = {
  height: number;
};
const ModalVertical = ({ height }: ModalVerticalProps) => {
  const { scaleTime } = useTimeAxisContext();
  const [{ modal }] = useTimelineTooltipStore();

  if (!modal) {
    return null;
  }
  const x = scaleTime(modal.t) || 0;
  const path = d3.line()([
    [x, 35],
    [x, height],
  ]);
  return (
    <g className="modalVertical">
      <path d={path || ""} />
    </g>
  );
};

export default ModalVertical;
